/* eslint-disable */
import { get } from '@bigyouth/base'
import { create } from '../utils/sigpipe'
import { get as getPipe } from '../utils/sigpipe'

export default {
  name: 'tabs',

  ui: {
    'listItems[]': '[js-tabs-link]',
  },

  events: [
    {
      target: 'listItems',
      on: 'click',
      handle: 'openTab',
    },
  ],

  componentDidMount() {
    this.checkChartsAPIloaded()
  },

  openTab(e) {
    let currentEl = e.target
    let parent = currentEl.closest('[js-tabs-list]')
    let oldActive = get('.is-active', parent)

    let target = get(currentEl.getAttribute('href'))
    let targetParent = target.closest('[js-tabs-wrapper]')
    let oldtargetActive = get(':scope > .is-active', targetParent)

    if (oldActive) oldActive.classList.remove('is-active')
    if (oldtargetActive) oldtargetActive.classList.remove('is-active')

    currentEl.classList.add('is-active')
    target.classList.add('is-active')
    this.drawCharts(target)

    e.preventDefault()
  },

  drawCharts(elt) {
    const element = elt.querySelector('.key-figure--sub')
      ? elt.querySelector('.key-figure--sub .key-figure__content.is-active')
      : elt

    /* for (let graph of element.querySelectorAll('[js-graph]')) {
      let pipe = getPipe(graph.getAttribute('data-pipe-id'))
      if (pipe) {
        pipe.write({ action: 'draw' })
      }
    } */
    // refact for IE 11......
    for (var i = 0; i < element.querySelectorAll('[js-graph]').length; ++i) {
      var pipe = getPipe(
        element.querySelectorAll('[js-graph]')[i].getAttribute('data-pipe-id')
      )
      if (pipe) {
        pipe.write({ action: 'draw' })
      }
    }
  },

  drawFirstTabCharts() {
    // draw charts of first tab
    this.drawCharts(
      document.querySelector('.key-figure--sub .key-figure__content.is-active')
    )
  },

  checkChartsAPIloaded() {
    // this.pipeId = this.el.getAttribute('data-chartAPI-pipe-id')
    if (!window.chartsAPIpipe) {
      // charts API not loaded already
      window.chartsAPIpipe = create()
      this.el.setAttribute('data-chartAPI-pipe-id', window.chartsAPIpipe.id)
      // this.pipe = getPipe(pipeId)
      window.chartsAPIpipe.on(({ action }) => {
        // waiting for API loading
        switch (action) {
          case 'chartsAPI-loaded':
            this.drawFirstTabCharts()
            break
          default:
            console.og('error in action pipe')
            break
        }
      })
    } else {
      // Charts API already loaded, let's go
      // window.chartsAPIpipe.destroy()
      this.drawFirstTabCharts()
    }
  },
}

window.helloGcharts = function() {
  if (window.chartsAPIpipe) {
    // API loaded after component init, so 'emit' to init charts
    window.chartsAPIpipe.write({ action: 'chartsAPI-loaded' })
  } else {
    // API loaded before component init, pipe created only to let component auto init
    window.chartsAPIpipe = create()
  }
}
